<!-- 索赔发货 -->
<template>
	<div>
		<div class="mb10">
			<el-button
				type="primary"
				size="small"
				class="table-toolbar-btn"
				@click="handleExport"
				v-if="perms.includes('home:repair:normalRepair:shipping:export')">
				导出
			</el-button>
			<div class="search-wrapper">
				<span class="top-label">状态</span>
				<el-select v-model="dealFlag" size="small" placeholder="请选择状态" @change="handleSearch">
					<el-option label="待处理" value="1"></el-option>
					<el-option label="待处理_无货等待" value="3"></el-option>
					<el-option label="已处理" value="2"></el-option>
				</el-select>
			</div>
			<div class="search-wrapper">
				<span class="top-label">索赔类型</span>
				<el-select v-model="repairType" size="small" clearable placeholder="全部" @change="handleSearch">
					<el-option v-for="option in claimantRepairTypeOptions" :key="option.id" :label="option.name" :value="option.id"></el-option>
				</el-select>
			</div>
			<div class="search-wrapper">
				<span class="top-label">开始时间</span>
				<el-date-picker
					size="small"
					v-model="startTime"
					type="datetime"
					value-format="yyyy-MM-dd HH:mm:ss"
					placeholder="请选择"
					@change="handleSearch"></el-date-picker>
			</div>
			<div class="search-wrapper">
				<span class="top-label">结束时间</span>
				<el-date-picker
					size="small"
					v-model="endTime"
					type="datetime"
					value-format="yyyy-MM-dd HH:mm:ss"
					placeholder="请选择"
					@change="handleSearch"></el-date-picker>
			</div>
		</div>
		<div class="mb20" :class="perms.includes('home:repair:normalRepair:shipping:export') ? 'pl55' : ''">
			<div class="search-wrapper">
				<span class="top-label">机号</span>
				<el-input v-model="repairDeviceNumberLike" size="small" placeholder="请输入机号" @input="handleSearch"></el-input>
			</div>
			<div class="search-wrapper">
				<span class="top-label">机型名称</span>
				<el-input v-model="repairDeviceNameLike" size="small" placeholder="请输入机型名称" @input="handleSearch"></el-input>
			</div>
			<div class="search-wrapper">
				<span class="top-label">流水号编号</span>
				<el-input v-model="serialNumberLike" size="small" placeholder="请输入流水号编号" @input="handleSearch"></el-input>
			</div>
			<div class="search-wrapper">
				<span class="top-label">申请方</span>
				<el-input v-model="applyOrgNameLike" size="small" placeholder="请输入申请方" @input="handleSearch"></el-input>
			</div>
		</div>
		<div>
			<el-table :data="dataList" :row-class-name="tableRowClassName" :header-cell-style="{ color: '#444' }" class="scroll-table" style="width: 100%">
				<el-table-column label="NO." width="60">
					<template slot-scope="scope">
						<span class="no">{{ scope.$index + 1 }}</span>
					</template>
				</el-table-column>
				<el-table-column label="编号" width="150" show-overflow-tooltip>
					<template slot-scope="scope">
						{{ scope.row.isSubmit == 0 || scope.row.serialNumber == null ? "暂无" : scope.row.serialNumber }}
					</template>
				</el-table-column>
				<el-table-column label="索赔类型" width="160" show-overflow-tooltip>
					<template slot-scope="scope">
						{{ getClaimantRepairTypeOptionsText(scope.row.repairType) }}
					</template>
				</el-table-column>
				<el-table-column label="节点" width="160" show-overflow-tooltip>
					<template slot-scope="scope">
						{{ getClaimantRepairText(scope.row.currentAudit) }}
					</template>
				</el-table-column>
				<el-table-column prop="applyOrgName" label="申请方公司" width="200" show-overflow-tooltip></el-table-column>
				<el-table-column prop="createUsrNamePhone" label="发起人" width="200" show-overflow-tooltip></el-table-column>
				<el-table-column label="类型" prop="" width="">
					<template slot-scope="scope">
						{{ matertialTypes[scope.row.matertialType] }}
					</template>
				</el-table-column>
				<el-table-column prop="submitTime" label="受理日期" width="100" show-overflow-tooltip>
					<template slot-scope="scope">
						{{ scope.row.submitTime ? formatTimestamp(scope.row.submitTime) : "" }}
					</template>
				</el-table-column>
				<el-table-column prop="repairDeviceName" label="机型及开发名" width="200" show-overflow-tooltip></el-table-column>
				<el-table-column prop="repairDeviceNumber" label="机号" width="200" show-overflow-tooltip></el-table-column>
				<el-table-column prop="auditOrgName" label="一级审核方" width="120" show-overflow-tooltip></el-table-column>
				<el-table-column prop="partsClaimCustomer.userName" label="客户信息" width="120" show-overflow-tooltip></el-table-column>
				<el-table-column prop="installDate" label="安装日期" width="100">
					<template slot-scope="scope">
						{{ scope.row.installDate ? formatTimestamp(scope.row.installDate) : "" }}
					</template>
				</el-table-column>
				<el-table-column prop="invoiceDate" label="发票日期" width="100">
					<template slot-scope="scope">
						{{ scope.row.invoiceDate ? formatTimestamp(scope.row.invoiceDate) : "" }}
					</template>
				</el-table-column>
				<el-table-column prop="faultDate" label="故障发生日期" width="120">
					<template slot-scope="scope">
						{{ scope.row.faultDate ? formatTimestamp(scope.row.faultDate) : "" }}
					</template>
				</el-table-column>
				<el-table-column prop="warrantyEnd" label="保修截至日期" width="120">
					<template slot-scope="scope">
						{{ scope.row.warrantyEnd ? formatTimestamp(scope.row.warrantyEnd) : "" }}
					</template>
				</el-table-column>
				<el-table-column
					prop="auditDuration"
					label="资料审核耗时"
					width="120"
					:render-header="(h, obj) => renderHeader(h, obj, '索赔从正式提交到资料审核结束的工作时长(小时)')"></el-table-column>
				<el-table-column
					prop="shippingDuration"
					label="实物邮寄耗时"
					width="120"
					:render-header="(h, obj) => renderHeader(h, obj, '资料审核结束到发起方完成实物邮寄的工作时长(小时)')"></el-table-column>
				<el-table-column
					prop="serviceTestDuration"
					label="服务部测试耗时"
					width="140"
					:render-header="(h, obj) => renderHeader(h, obj, '如果需要服务部测试，从申请方发货到服务部测试完成的工作时长(小时)')"></el-table-column>
				<el-table-column
					prop="physicalInspectionDuration"
					label="实物检测耗时"
					width="120"
					:render-header="(h, obj) => renderHeader(h, obj, '申请方完成邮寄或者无需邮寄到实物检测完成的工作时长(小时)')"></el-table-column>
				<el-table-column
					prop="claimShippingDuration"
					label="索赔发货耗时"
					width="120"
					:render-header="(h, obj) => renderHeader(h, obj, '实物检测通过到索赔最终全部发货的工作时长(小时)')"></el-table-column>
				<el-table-column
					prop="testItemReturnDuration"
					label="测试件寄回耗时"
					width="140"
					:render-header="(h, obj) => renderHeader(h, obj, '实物检测完毕到测试件寄回的工作时长(小时)')"></el-table-column>
				<el-table-column
					prop="totalDuration"
					label="全单耗时"
					width="120"
					:render-header="(h, obj) => renderHeader(h, obj, '索赔从正式发起到索赔成功并且索赔件寄出的工作时长(小时)')"></el-table-column>
				<el-table-column fixed="right" label="操作" width="100">
					<template slot-scope="scope">
						<el-button type="primary" size="small" @click="handleEdit(scope.row)">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination-wrapper pa25">
				<Pagination
					:page.sync="pageNo"
					:pageSize.sync="pageSize"
					:total="total"
					@sizeChange="handleSizeChange"
					@currentChange="handleCurrentChange"></Pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { claimDeliveryList, dataShippingExport } from "@/api/claim";
import Pagination from "@/components/Pagination";
import { claimantRepairTypeOptions } from "@/constant/options";
import { debounce } from "@/utils/debounce";
export default {
	components: {
		Pagination,
	},
	data() {
		return {
			// 权限
			perms: JSON.parse(window.sessionStorage.getItem("perms")),
			claimantRepairTypeOptions,
			pageNo: 1,
			pageSize: 10,
			total: 0,
			dataList: [],
			dealFlag: "1",
			repairType: "",
			serialNumberLike: "", // 流水号编号
			applyOrgNameLike: "", // 申请方
			repairDeviceNumberLike: "", // 机号
			repairDeviceNameLike: "", // 机型名称
			matertialTypes: {
				1: "主机",
				2: "耗材",
				3: "选购件",
				4: "零件",
			},
			startTime: "",
			endTime: "",
		};
	},
	mounted() {
		// 删除索赔id
		sessionStorage.removeItem("claimId");
		// 获取索赔列表
		this.getPartsClaimList();
	},
	methods: {
		// 获取索赔类型名称
		getClaimantRepairTypeOptionsText(val) {
			for (const option of this.claimantRepairTypeOptions) {
				if (option.id === val) {
					return option.name;
				}
			}
		},
		// 获取索赔状态名称
		getClaimantRepairText(val) {
			if (val === undefined || val === null) {
				return "待提交";
			}
			return val.operNotes || "待提交";
		},
		// NO.隔行变色
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 1) {
				return "blue";
			} else {
				return "yellow";
			}
		},
		formatTimestamp(ms, datetime) {
			const _fmt = datetime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";
			return this.$moment(new Date(ms)).format(_fmt);
		},
		// 获取索赔列表
		getPartsClaimList() {
			let self = this;
			const params = {
				pageNo: self.pageNo,
				pageSize: self.pageSize,
				dealFlag: self.dealFlag,
				repairType: self.repairType,
				serialNumberLike: self.serialNumberLike,
				applyOrgNameLike: self.applyOrgNameLike,
				repairDeviceNumberLike: self.repairDeviceNumberLike,
				repairDeviceNameLike: self.repairDeviceNameLike,
				startTime: self.startTime,
				endTime: self.endTime,
			};
			claimDeliveryList(params, true)
				.then((r) => {
					if (r.code == "0") {
						self.dataList = r.data.list;
						self.total = r.data.totalCount;
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
		handleSizeChange() {
			this.getPartsClaimList();
		},
		handleCurrentChange() {
			this.getPartsClaimList();
		},
		handleSearch: debounce(function () {
			this.pageNo = 1;
			this.getPartsClaimList();
		}, 1000),
		// 新增
		handleAdd() {
			this.$router.push({
				name: "claimCreate",
			});
		},
		// 编辑
		handleEdit(row) {
			sessionStorage.setItem("claimId", row.id);
			sessionStorage.setItem("repairType", row.repairType);
			sessionStorage.setItem("dealFlag", this.dealFlag == "2" ? "2" : "1");
			sessionStorage.setItem("claimInfo", JSON.stringify(row));
			let flag1 = [-2, -3].includes(row?.currentAudit?.auditStatus);
			let flag2 = row.isSubmit == 0 && row.currentAudit == null;
			const routeName = flag1 || flag2 ? "claimCreate" : "claimDetail";
			this.$router.push({
				name: routeName,
				query: {
					claimId: row.id,
					repairType: row.repairType,
					menuAction: "3",
				},
			});
		},
		// 列标题修改
		renderHeader(h, { column, $index }, content_desc) {
			return [
				column.label,
				h(
					"el-tooltip",
					{
						props: {
							content: content_desc,
							placement: "top",
						},
					},
					[h("span", { class: { "el-icon-question": true } })],
				),
			];
		},
		// 导出
		handleExport() {
			let self = this;
			const params = {
				dealFlag: self.dealFlag,
				repairType: self.repairType,
				serialNumberLike: self.serialNumberLike,
				applyOrgNameLike: self.applyOrgNameLike,
				repairDeviceNumberLike: self.repairDeviceNumberLike,
				repairDeviceNameLike: self.repairDeviceNameLike,
				startTime: self.startTime,
				endTime: self.endTime,
			};
			dataShippingExport(params, true)
				.then((r) => {
					if (r.code == "0") {
						const linkNode = document.createElement("a");
						linkNode.style.display = "none";
						linkNode.href = r.data;
						document.body.appendChild(linkNode);
						linkNode.click(); //模拟在按钮上的一次鼠标单击
						URL.revokeObjectURL(linkNode.href); // 释放URL 对象
						document.body.removeChild(linkNode);
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
	},
};
</script>

<style lang="scss" scoped>
.ml10 {
	margin-left: 10px;
}
.top-label {
	margin: 0 10px;
	color: #606266;
	font-size: 14px;
}
.search-wrapper {
	display: inline-block;
	margin-left: 10px;
	margin-top: 10px;
	.el-select,
	.el-input {
		width: 200px;
	}
}
.pl55 {
	padding-left: 55px;
}
</style>
